import { DocumentStatusWithSent } from '@/components/modules/Documentation/types/DocumentStatusWithSent';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export function useDocStatuses() {
  const { palette } = useCustomTheme();
  return {
    [DocumentStatusWithSent.SENT]: {
      color: palette.success.main,
      textColor: palette.success.contrastText,
      descriptionTId: 'DOCUMENTATION_SENT_ON',
    },
    [DocumentStatusWithSent.PENDING]: {
      color: palette.grey[200],
      textColor: palette.grey[700],
      descriptionTId: 'UPLOAD_PENDING',
    },
    [DocumentStatusWithSent.UPLOADED]: {
      color: palette.info.main,
      textColor: palette.info.contrastText,
      descriptionTId: 'ALL_DOCUMENTS_UPLOADED',
    },
    [DocumentStatusWithSent.INCIDENCE]: {
      color: palette.warning.main,
      textColor: palette.warning.contrastText,
      descriptionTId: 'INCIDENCE_IN_DOCUMENTS',
    },
    [DocumentStatusWithSent.VALIDATED]: {
      color: palette.success.main,
      textColor: palette.success.contrastText,
      descriptionTId: 'DOCUMENT_VALIDATED',
    },
  };
}
